import { useNavigate } from 'react-router-dom';
import { AlertTriangle, Calendar } from 'lucide-react';

export function InviteConflictPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-bg-primary flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-teal mb-4">
            <Calendar className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-2xl font-semibold text-text-primary">Family Calendar</h1>
        </div>

        {/* Error Card */}
        <div className="card text-center">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-orange/20 mb-4">
            <AlertTriangle className="w-6 h-6 text-orange" />
          </div>

          <h2 className="text-lg font-semibold text-text-primary mb-2">
            Account Conflict
          </h2>

          <p className="text-text-secondary mb-6">
            The account you signed in with is already associated with a different family.
          </p>

          <div className="bg-bg-secondary rounded-lg p-4 mb-6">
            <p className="text-sm text-text-secondary">
              Each account can only belong to one family at a time.
              If you'd like to join this family, please sign in with a different Google or Microsoft account,
              or contact your current family's admin to leave that family first.
            </p>
          </div>

          <div className="space-y-3">
            <button
              onClick={() => navigate('/login')}
              className="btn btn-primary w-full"
            >
              Sign In with Different Account
            </button>
            <button
              onClick={() => navigate('/')}
              className="btn btn-secondary w-full"
            >
              Go to Home
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
